// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"356":"57c4fa45","431":"57c4fa45"}[chunkId] + ".chunk.css";
};